import { useCallback, useRef, useState } from "react";

import { Tooltip, Popover } from "antd";
import Picker, { IEmojiData } from "emoji-picker-react";

import { useClickOutside } from "../../../hooks/useClickOutside/useClickOutside";
import { RVIcon, RVIconSizeOptions } from "../../atoms/RVIcon/RVIcon";

import styles from "./RVEmojiPicker.module.scss";

const DEFAULT_TOOLTIP_DISPLAY_DELAY = 1;

type RVEmojiPickerProps = {
    value?: string | null;
    onChange?: (emoji: string) => void;
};

export const RVEmojiPicker = ({ value, onChange }: RVEmojiPickerProps) => {
    const popoverRef = useRef<any>(null);
    const iconRef = useRef<any>(null);
    const [emojiPickerOpen, setEmojiPickerOpen] = useState<boolean>(false);
    useClickOutside([popoverRef, iconRef], () => setEmojiPickerOpen(false));

    const handleOpenPicker = useCallback(
        (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            e.stopPropagation();
            setEmojiPickerOpen((prev) => !prev);
        },
        [setEmojiPickerOpen]
    );
    const handleEmojiSelected = useCallback(
        (event: React.MouseEvent, data: IEmojiData) => {
            setEmojiPickerOpen(false);
            onChange?.(data.emoji);
        },
        [setEmojiPickerOpen, onChange]
    );

    return (
        <Popover
            placement="topLeft"
            content={
                <div ref={popoverRef}>
                    <Picker onEmojiClick={handleEmojiSelected} disableAutoFocus={true} native />
                </div>
            }
            open={emojiPickerOpen}
            overlayClassName={styles.popover}
            align={{ offset: [-20, 0] }} // place it exactly above emoji
        >
            <Tooltip title="Emojis" mouseEnterDelay={DEFAULT_TOOLTIP_DISPLAY_DELAY}>
                <div ref={iconRef} onClick={handleOpenPicker} className={styles.refWrapper}>
                    {value || (
                        <RVIcon icon="smiley" size={RVIconSizeOptions.SMALL} data-dd-action-name="Emoji picker" />
                    )}
                </div>
            </Tooltip>
        </Popover>
    );

    // return <div>HELL COMP</div>;
};
